// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2XydV","option":"styles_option__FUdBW","active":"styles_active__1yVTV"};